import React, { useState, useEffect } from "react";
import styles from "./prizes.module.css";
import img from "../../assets/prizes/Vector 14.png";
import ArrowLeft from "../../assets/prizes/Vector 12.png";
import ArrowRight from "../../assets/prizes/Vector 11.png";
import Przie_b from "../../assets/prize_b.svg";
import { Link } from "react-scroll";

const Prizes = () => {
  const prizes = [
    {
      prize: "Cash Prize Worth ₹50K",
    },
    {
      prize: "Performance slot at Mood Indigo' Food Fest",
    },
    {
      prize: "Studio time for winners",
    },
    {
      prize: "Gig Performance by Blue Tree",
    },
    {
      prize: "Gear coupons worth ₹60K from Furtados",
    },
  ];

  const [slide, setSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSlide((prev) => (prev === prizes.length - 1 ? 0 : prev + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, [prizes.length]);

  const SelectClass = (index) => {
    if (slide === index) {
      return styles.active;
    } else if (slide === index + 1 || slide === index - 1) {
      if (slide === index + 1) {
        return styles.left1;
      } else {
        return styles.right1;
      }
    } else if (slide === index + 2 || slide === index - 2) {
      if (slide === index + 2) {
        return styles.left2;
      } else {
        return styles.right2;
      }
    } else if (slide === 0) {
      if (index === prizes.length - 1) {
        return styles.left1;
      } else if (index === prizes.length - 2) {
        return styles.left2;
      }
    } else if (slide === 1) {
      if (index === prizes.length - 1) {
        return styles.left2;
      }
    } else if (slide === prizes.length - 1) {
      if (index === 0) {
        return styles.right1;
      } else if (index === 1) {
        return styles.right2;
      }
    } else if (slide === prizes.length - 2) {
      if (index === 0) {
        return styles.right2;
      }
    } else {
      return styles.hidden;
    }
  };

  const setNextSlide = () => {
    setSlide((prev) => (prev === prizes.length - 1 ? 0 : prev + 1));
  };
  const setPreviousSlide = () => {
    setSlide((next) => (next === 0 ? prizes.length - 1 : next - 1));
  };
  return (
    <div className={styles.prizes}>
      <div className={styles.prizes_head}>
        <img src={Przie_b} alt="pirz" className={styles.prize_head} />
        <p className={styles.heading}>PRIZES</p>
        <img
          src={Przie_b}
          alt="pirz"
          className={styles.prize_head}
          style={{ transform: "rotate(180deg)" }}
        />
      </div>
      <div className={styles.container}>
        {prizes.map((item, indx) => (
          <div className={`${styles.slide} ${SelectClass(indx)}`}>
            <div className={styles.textbox}>
              <p>{item.prize}</p>
            </div>
            <img src={img} alt="facsdf" />
          </div>
        ))}
        <div className={styles.arrows}>
          <img src={ArrowLeft} onClick={setPreviousSlide} alt="arrow" />
          <img src={ArrowRight} onClick={setNextSlide} alt="arrow" />
        </div>
      </div>
      <div id="register">
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className={`${styles.registerBtn} ${styles.redbtn}`}>REGISTER</button>
        </a>
      </div>
    </div>
  );
};

export default Prizes;
